import React from "react";
import FormInput from "Common/Custom/FormInput";
import FormInputFile from "Common/Custom/FormInputFile";
import FormSubmitButton from "Common/Custom/FormSubmitButton";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import Switch from "Common/Custom/Switch";
import FormSelect from "Common/Custom/FormSelect";
import FormPhoneInput from "Common/Custom/FormPhoneInput";
import FormDatePicker from "Common/Custom/ReactFlatpickr";
import CountryName from "Common/json/CountryName.json";
import FormTextarea from "Common/Custom/FormTextarea";


const EditCustomerForm = ({
  fields,
  values,
  errors,
  handleChange,
  handleFileChange,
  handleSubmit,
  loading,
  img_frontPreview,
  img_backPreview,
  img_guestPreview,
  profile_imagePreview
}) => {
  const { common, native, foreigner } = fields;
  const nationality = values.is_nationality;
  const countryOptions = CountryName.map((country) => ({
    value: country.name,
    label: country.name,
  }));
  var imgPreview = '';

  const renderField = (field) => {
    switch (field.type) {
      case "file":
        if (field.name === "img_front") {
          imgPreview = img_frontPreview
        } else if (field.name === "img_back") {
          imgPreview = img_backPreview
        } else if (field.name === "img_guest") {
          imgPreview = img_guestPreview
        } else if (field.name === "profile_image") {
          imgPreview = profile_imagePreview
        } else {
          imgPreview = ''
        }
        return (
          <FormInputFile
            key={field.name}
            field={field}
            handleChange={handleFileChange}
            error={errors[field.name]}
            imagePreview={
              imgPreview
            }
          />
        );

      case "switch":
        return (
          <Switch
            key={field.name}
            values={values[field.name]}
            handleChange={handleChange}
            field={field}
            ValueOne="1"
            ValueTwo="0"
            LabelOne="Active"
            LabelTwo="Inactive"
          />
        );

      case "select":
        return (
          <FormSelect
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            options={(field.name == "nationality" || field.name == "country") ? countryOptions : field.options}
            error={errors[field.name]}
          />
        );

      case "tel":
        return (
          <FormPhoneInput
            key={field.name}
            field={field}
            value={values[field.name]}
            country_code={values['country_dial_code']}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      case 'date':
        return (
          <FormDatePicker
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={null}
            dateFormat="Y-m-d"
          />
        );
      case 'textarea':
        return (
          <FormTextarea
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
      default:
        return (
          <FormInput
            key={field.name}
            field={field}
            value={values[field.name]}
            handleChange={handleChange}
            error={errors[field.name]}
          />
        );
    }
  };

  return (
    <PageBody onSubmit={handleSubmit} headerchildren={<HeadingOne>Update Customer</HeadingOne>}>
      {/* Always show common fields */}
      {common.map(renderField)}

      {/* Conditional fields based on nationality */}
      {nationality === "national" && native.map(renderField)}
      {nationality === "foreigner" && foreigner.map(renderField)}

      {/* Submit button */}
      <FormSubmitButton
        label="Update"
        loading={loading}
        colSize="col-12"
        align="end"
      />
    </PageBody>
  );
};

export default EditCustomerForm;